import { render, staticRenderFns } from "./VueIframeWritable.vue?vue&type=template&id=3c17f6ec&scoped=true&"
import script from "./VueIframeWritable.vue?vue&type=script&lang=js&"
export * from "./VueIframeWritable.vue?vue&type=script&lang=js&"
import style0 from "./VueIframeWritable.vue?vue&type=style&index=0&id=3c17f6ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17f6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c17f6ec')) {
      api.createRecord('3c17f6ec', component.options)
    } else {
      api.reload('3c17f6ec', component.options)
    }
    module.hot.accept("./VueIframeWritable.vue?vue&type=template&id=3c17f6ec&scoped=true&", function () {
      api.rerender('3c17f6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueIframeWritable.vue"
export default component.exports